import { useState, useContext, useEffect } from 'react';
import './CardEnrollment.css';
import { CardElementData } from '@adyen/adyen-web/dist/types/components/Card/types';
import { AppContext } from '../context';
import { createPayment } from '../lib/paymentService';
import { wait } from '../lib/util';
import Balls from '../components/Balls';
import { ERRORS, mapErrorMessage } from '../lib/errors';
import { PaymentAction } from '@adyen/adyen-web/dist/types/types';
import CardHandler from './CardHandler';
import AdyenCore from '@adyen/adyen-web/dist/types/core';

export default function CardEnrollment(): JSX.Element {
  const [cardData, setCardData] = useState<null | CardElementData>(null);
  const [binValue, setBinValue] = useState<string>(''); // first 6-8 digits captured from Adyen callbacks
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [threeDSData, setThreeDSData] = useState<null | PaymentAction>(null);
  const [adyenSdk, setAdyenSdk] = useState<AdyenCore>();
  const context = useContext(AppContext);

  const blockedBins: string[] = [
    '446617', // Klarna BIN
  ];

  const handleCardData = (data: CardElementData) => {
    setCardData(data);
  };

  const isCardBinSupported = (data: CardElementData | null): boolean => {
    if (!data) return false;
    if (binValue && blockedBins.includes(binValue.substring(0, 6))) return false;
    return true;
  };

  const onRegisterHandler = async () => {
    if (cardData == null) {
      setErrorMessage(mapErrorMessage(context, ERRORS.INVALID_INPUT));
    } else if (!isCardBinSupported(cardData)) {
      setErrorMessage(mapErrorMessage(context, ERRORS.KLARNA_NOT_SUPPORTED));
    } else {
      setErrorMessage('');
      setLoading(true);
      const [err, response] = await Promise.all([
        createPayment(context, cardData as CardElementData),
        wait(1000),
      ]).then(([v]) => v);
      setLoading(false);
      if (err) {
        setErrorMessage(mapErrorMessage(context, err));
      } else {
        setThreeDSData(response);
      }
    }
  };

  useEffect(() => {
    if (!adyenSdk) {
      context.enrollmentAdyenSdk().then((sdk) => setAdyenSdk(sdk));
    }
  });

  return (
    <div className={`card-enrollment ${loading && 'loading'}`}>
      {loading || !adyenSdk ? (
        <Balls />
      ) : (
        <div className="card-entry">
          <CardHandler
            handleCardData={handleCardData}
            threeDSData={threeDSData}
            adyenSdk={adyenSdk}
            setBinValue={setBinValue}
          />
          <div className={`card-register-error-msg ${errorMessage && 'visible'}`}>
            <p>{errorMessage}</p>
          </div>
          <div className="card-register-button-group">
            <button onClick={onRegisterHandler}>{context.texts.payButton}</button>
          </div>
        </div>
      )}
    </div>
  );
}
